import axios from 'axios'

export class AwsService {
  async uploadBlob(blob: Blob, url: string) {
    try {
      return await axios.put(url, blob)
    } catch (error) {
      throw error
    }
  }
}
